// Redux Utils
import { useDispatch, useSelector } from "react-redux";
import { eliminarEvento } from "@/features/evento/eventoThunks";

// React Utils
import React, { useState } from "react";
import { useParams } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import bckWoop from "@/assets/Logo-AppWhoop.webp"; // Placeholder image for lazy loading
import { Link } from "react-router-dom";

// Contextos
import { useModalsContext } from "@/contexts/ModalsContext";

// Components
import DropdownMenu from "@/components/DropdownMenu";
import Modal from "@/components/Modals/Modal";
import PublicarEvento from "@/components/Forms/PublicarEvento";
import DuplicarEvento from "@/components/Forms/DuplicarEvento";

// Utils
import { scrollToTop, formatFechaHoraEvento } from "@/lib/utilsUI";
import { parseUTCDate, DEFAULT_TIMEZONE } from "@/utils/dateHelpers";
import { shareContent } from "@/utils/shareUtil";

export default function TicketCardPerfilEmpresaViewOwnEmpresa({
  ticket,
  idEmpresa,
  additionalProps = {},
}) {
  console.log(
    "[Renderizando] TicketCardPerfilEmpresaViewOwnEmpresa con additionalProps:",
    additionalProps,
  );

  const { user } = useSelector((state) => state.auth);
  // Formatear fecha del evento usando UTC
  const formatDatetime = ticket?.fechaHoraInicio
    ? formatFechaHoraEvento(
        parseUTCDate(
          ticket.fechaHoraInicio,
          ticket.zonaHoraria || DEFAULT_TIMEZONE,
        )?.toJSDate(),
        ticket.zonaHoraria || DEFAULT_TIMEZONE,
      )
    : null;

  // Estado local para el modal de publicar evento
  const [showPublishModal, setShowPublishModal] = useState(false);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [warningMessage, setWarningMessage] = useState({
    title: "",
    message: "",
    showLink: false,
  });
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  // Estado local para el nombre de confirmación al eliminar evento
  const [confirmEventName, setConfirmEventName] = useState("");
  const [showNameError, setShowNameError] = useState(false);

  // Redux States
  const dispatch = useDispatch();

  // console.log("TicketCardPerfilEmpresaViewOwnEmpresa - ticket:", idEmpresa, ticket?.uid);

  // Contextos
  const { openModal } = useModalsContext();

  // Función para manejar la eliminación del evento
  const handleDeleteEvento = async () => {
    // Verificar si el nombre coincide
    if (confirmEventName !== ticket?.nombre) {
      setShowNameError(true);
      return;
    }

    try {
      setIsDeleting(true);
      const result = await dispatch(
        eliminarEvento({ uidEvento: ticket?.uid }),
      ).unwrap();

      // Mostrar mensaje de éxito
      alert(
        `Evento "${
          result.nombreEvento || ticket?.nombre
        }" eliminado exitosamente`,
      );

      // Cerrar el modal
      setShowDeleteModal(false);

      // Recargar la página para actualizar la lista de eventos
      window.location.reload();
    } catch (error) {
      console.error("Error al eliminar evento:", error);
      alert(
        error || "Error al eliminar el evento. Por favor, intenta de nuevo.",
      );
      setIsDeleting(false);
    }
  };

  // Función para verificar si se puede publicar el evento
  const handlePublishAttempt = () => {
    const empresaPublished = additionalProps?.empresaPublished;

    if (empresaPublished === 1) {
      // Empresa activada, permitir publicar
      setShowPublishModal(true);
    } else if (empresaPublished === 0) {
      // Empresa no ha enviado documentos
      setWarningMessage({
        title: "Empresa no activada",
        message:
          "Para poder publicar eventos, primero debes activar tu empresa enviando los documentos requeridos.",
        showLink: true,
      });
      setShowWarningModal(true);
    } else if (empresaPublished === 2) {
      // Empresa en revisión
      setWarningMessage({
        title: "Empresa en revisión",
        message:
          "Tus documentos están siendo revisados. Este proceso puede tomar hasta 2 días hábiles. Si ya han pasado más de 2 días, puedes contactarnos a support@appwhoop.com para consultar el estado.",
        showLink: false,
      });
      setShowWarningModal(true);
    } else {
      // Estado desconocido
      setWarningMessage({
        title: "Estado desconocido",
        message:
          "No se puede determinar el estado de tu empresa. Por favor, contacta a soporte.",
        showLink: false,
      });
      setShowWarningModal(true);
    }
  };

  // Example menu options
  const menuOptions = [
    {
      type: "none",
      classContent: "bg-aw-bluedark p-1.5",
    },
  ];

  const currentDateTime = new Date();
  const fechaHoraFinTicket = parseUTCDate(
    ticket?.fechaHoraFin,
    ticket?.zonaHoraria || DEFAULT_TIMEZONE,
  )?.toJSDate();

  if (ticket?.published === 1 && currentDateTime > fechaHoraFinTicket) {
    menuOptions.push(
      {
        type: "link",
        label: "Ver Evento",
        icon: "fa-solid fa-eye",
        to: `/evento/${ticket?.uid}`,
        className: "text-white hover:bg-aw-green/20",
      },
      {
        type: "link",
        label: "Dashboard Evento",
        icon: "fa-solid fa-gear",
        to: `/empresa/${idEmpresa}/evento/${ticket?.uid}/dashboard`,
        className: "text-white hover:bg-aw-green/20",
      },
      { divider: true },
      {
        type: "button",
        label: "Duplicar Evento",
        icon: "fa-solid fa-copy",
        onClick: () => setShowDuplicateModal(true),
        className: "text-white hover:bg-aw-green/20",
      },
    );
  } else if (ticket?.published === 1) {
    menuOptions.push(
      {
        type: "link",
        label: "Ver Evento",
        icon: "fa-solid fa-eye",
        to: `/evento/${ticket?.uid}`,
        className: "text-white hover:bg-aw-green/20",
      },
      {
        type: "link",
        label: "Ajustar Opciones",
        icon: "fa-solid fa-ticket",
        to: `/empresa/${idEmpresa}/evento/${ticket?.uid}`,
        className: "text-white hover:bg-aw-green/20",
      },
      {
        type: "link",
        label: "Dashboard Evento",
        icon: "fa-solid fa-gear",
        to: `/empresa/${idEmpresa}/evento/${ticket?.uid}/dashboard`,
        className: "text-white hover:bg-aw-green/20",
      },
      // { divider: true },
      // {
      //   type: "button",
      //   label: "Cancelar Evento",
      //   icon: "fa-solid fa-xmark-circle",
      //   onClick: () => openModal("cancelar"),
      //   className: "text-red-600 hover:bg-red-600/20",
      // },
      { divider: true },
      {
        type: "button",
        label: "Compartir Evento",
        icon: "fa-solid fa-share",
        onClick: () => console.log("Compartir evento"),
        className: "text-white hover:bg-aw-green/20",
      },
      {
        type: "button",
        label: "Duplicar Evento",
        icon: "fa-solid fa-copy",
        onClick: () => setShowDuplicateModal(true),
        className: "text-white hover:bg-aw-green/20",
      },
    );
  } else if (ticket?.published === 0) {
    menuOptions.push(
      {
        type: "link",
        label: "Actualizar Evento",
        icon: "fa-solid fa-ticket",
        to: `/empresa/${idEmpresa}/evento/${ticket?.uid}`,
        className: "text-white hover:bg-aw-green/20",
      },
      {
        type: "button",
        label: "Publicar Evento",
        icon: "fa-solid fa-play-circle",
        onClick: () => handlePublishAttempt(),
        className: "text-white hover:bg-aw-green/20",
      },
      {
        type: "button",
        label: "Duplicar Evento",
        icon: "fa-solid fa-copy",
        onClick: () => setShowDuplicateModal(true),
        className: "text-white hover:bg-aw-green/20",
      },
      { divider: true },
      {
        type: "button",
        label: "Eliminar Evento",
        icon: "fa-solid fa-trash",
        onClick: () => {
          setShowDeleteModal(true);
          setConfirmEventName("");
          setShowNameError(false);
        },
        className: "text-red-600 hover:bg-red-600/20",
      },
    );
  }

  // Función para compartir el link del evento
  const handleShare = async () => {
    const eventUrl = `${window.location.origin}/evento/${ticket?.uid}`;

    await shareContent({
      url: eventUrl,
      title: ticket?.nombre || "Evento",
      text: `¡Mira este evento! ${ticket?.nombre}`,
      successMessage: "¡Link del evento copiado al portapapeles!",
    });
  };

  return (
    <>
      <div className="min-w-[200px] max-w-[200px] bg-aw-bluedark rounded-b-xl shadow-lg overflow-hidden">
        {/* Imagen del Ticket */}
        {user === null ? (
          <Link
            to={`/evento/${ticket?.uid}`}
            onClick={scrollToTop}
            className="h-52 block overflow-hidden relative border-2 border-aw-green bg-aw-bluegray"
          >
            <img
              src={bckWoop} // Placeholder image for lazy loading
              alt="Placeholder"
              className="absolute inset-0 w-2/3 h-2/3 m-auto top-0 left-0 object-cover z-0"
            />
            <LazyLoadImage
              src={ticket?.imgEvento} // Use the placeholder image
              placeholderSrc={bckWoop} // Placeholder image
              alt={ticket?.nombre}
              height={"100%"}
              width={"100%"}
              effect="blur"
              className="w-full h-full object-cover z-50"
              loading="lazy"
            />
          </Link>
        ) : (
          <>
            <Link
              to={
                ticket?.published && additionalProps?.myself
                  ? `/empresa/${idEmpresa}/evento/${ticket?.uid}/dashboard`
                  : ticket?.published
                    ? `/evento/${ticket?.uid}`
                    : additionalProps?.myself
                      ? `/empresa/${idEmpresa}/evento/${ticket?.uid}`
                      : `/evento/${ticket?.uid}`
              }
              onClick={ticket?.uid != null && scrollToTop}
              className="h-52 block overflow-hidden relative border-2 border-aw-green bg-aw-bluegray"
            >
              {/* TODO: Colocar otros estados según corresponda */}

              {ticket?.published &&
              ticket?.fechaHoraFin != null &&
              parseUTCDate(
                ticket?.fechaHoraFin,
                ticket?.zonaHoraria || DEFAULT_TIMEZONE,
              )?.toJSDate() < new Date() ? (
                <div className="absolute bg-red-600/60 text-white font-semibold text-center w-full py-1 z-40 rotate-45 top-5 -right-16 border-2 border-aw-blueblack">
                  Finalizado
                </div>
              ) : ticket?.published ? (
                <div className="absolute bg-aw-green text-aw-bluedark font-semibold text-center w-full py-1 z-40 rotate-45 top-5 -right-16 border-2 border-aw-blueblack">
                  Publicado
                </div>
              ) : (
                <></>
              )}
              <img
                src={bckWoop} // Placeholder image for lazy loading
                alt="Placeholder"
                className="absolute inset-0 w-2/3 h-2/3 m-auto top-0 left-0 object-cover z-0"
              />
              <LazyLoadImage
                src={ticket?.imgEvento} // Use the placeholder image
                placeholderSrc={bckWoop} // Placeholder image
                alt={ticket?.nombre}
                height={"100%"}
                width={"100%"}
                effect="blur"
                className="w-full h-full object-cover z-50"
                loading="lazy"
              />
            </Link>
          </>
        )}

        <div className="px-2 py-1 flex flex-col justify-between h-[130px] text-center">
          <span className="text-tiny text-white">
            {formatDatetime || "Fecha no definida"}
          </span>
          <h3 className="font-bold text-sm text-white line-clamp-2">
            {ticket?.nombre}
          </h3>
          {ticket?.enPromocion === 1 && (
            <span className="text-aw-green font-bold text-sm">
              {ticket?.textoPromocion}
            </span>
          )}
          <p className="text-xs text-gray-500 line-clamp-1">
            <FontAwesomeIcon
              icon="fa-solid fa-map-pin"
              className="text-red-700 mr-1"
            />
            {ticket?.direccion != null
              ? ticket?.direccion
              : "Aún sin dirección"}
          </p>
        </div>
        {/* Menú de Opciones */}
        <div
          className={`flex justify-between items-center border-aw-bluedark-50 ${user !== null && additionalProps?.myself === true ? "px-2 py-1 border-t" : ""}`}
        >
          {/* Botón para compartir el link del evento /evento/:idEvento a otros */}
          {user !== null &&
            additionalProps?.myself === true && ( // Temporal, luego integrar Vista Privada vs Pública
              <>
                <button
                  onClick={handleShare}
                  className="w-8 h-8 flex items-center justify-center bg-aw-bluedark-50 text-white font-semibold rounded-full hover:bg-aw-green hover:text-aw-bluedark transition border-2 border-aw-bluegray hover:border-aw-green active:border-aw-green"
                >
                  <FontAwesomeIcon icon="fa-solid fa-share-nodes" />
                </button>
                <span className="text-xs text-gray-500">Opciones</span>
                <DropdownMenu
                  trigger={
                    <button className="w-8 h-8 flex items-center justify-center bg-aw-bluedark-50 text-white font-semibold rounded-full hover:bg-aw-green hover:text-aw-bluedark transition border-2 border-aw-bluegray hover:border-aw-green active:border-aw-green">
                      <FontAwesomeIcon icon={"fa-solid fa-ellipsis"} />
                    </button>
                  }
                  options={menuOptions}
                  direction="up"
                  align="end"
                  classContent={menuOptions[0]?.classContent || "white"}
                />
              </>
            )}

          {(user === null || additionalProps?.myself === false) &&
            !additionalProps?.finally && (
              <Link
                to={`/evento/${ticket?.uid}`}
                onClick={scrollToTop}
                className={`w-full h-9 flex items-center justify-center bg-aw-green text-black font-semibold text-sm mt-2 py-1 hover:scale-110 transition duration-300`}
              >
                Comprar Ticket
                <FontAwesomeIcon
                  icon="fa-solid fa-ticket"
                  className="ml-2 -rotate-z-45"
                />
              </Link>
            )}
        </div>
      </div>

      {/* Modal para publicar evento específico */}
      {showPublishModal && (
        <Modal
          isOpen={showPublishModal}
          onClose={() => setShowPublishModal(false)}
          large="max-w-4xl"
        >
          <PublicarEvento
            onClose={() => setShowPublishModal(false)}
            eventoUid={ticket?.uid} // Pasar el UID específico del evento
          />
        </Modal>
      )}

      {/* Modal de advertencia para empresas no activadas */}
      {showWarningModal && (
        <Modal
          isOpen={showWarningModal}
          onClose={() => setShowWarningModal(false)}
          large="max-w-lg"
        >
          <div className="p-6 text-center bg-aw-bgbluedark rounded-lg">
            <FontAwesomeIcon
              icon="fa-solid fa-exclamation-triangle"
              className="text-yellow-500 mb-4"
              size="3x"
            />
            <h3 className="text-lg text-white font-semibold mb-4">
              {warningMessage.title}
            </h3>
            <p className="mt-2 text-gray-200 mb-6">{warningMessage.message}</p>

            <div className="flex flex-col gap-3">
              {warningMessage.showLink && (
                <Link
                  to={`/empresa/${idEmpresa}/activar`}
                  onClick={() => setShowWarningModal(false)}
                  className="px-6 py-3 bg-aw-green text-aw-bluedark rounded-lg font-semibold hover:scale-95 transition-all"
                >
                  Ir a activar empresa
                </Link>
              )}

              <button
                onClick={() => setShowWarningModal(false)}
                className={`px-6 py-3 ${
                  warningMessage.showLink
                    ? "bg-gray-600 text-white"
                    : "bg-aw-green text-aw-bluedark"
                } rounded-lg font-semibold hover:scale-95 transition-all`}
              >
                {warningMessage.showLink ? "Cerrar" : "Entendido"}
              </button>
            </div>
          </div>
        </Modal>
      )}

      {/* Modal de confirmación para eliminar evento */}
      {showDeleteModal && (
        <Modal
          isOpen={showDeleteModal}
          onClose={() => {
            if (!isDeleting) {
              setShowDeleteModal(false);
              setConfirmEventName("");
              setShowNameError(false);
            }
          }}
          large="max-w-lg"
        >
          <div className="p-6 text-center bg-aw-bgbluedark rounded-lg inset-shadow-sm inset-shadow-aw-green shadow-sm shadow-aw-green">
            <FontAwesomeIcon
              icon="fa-solid fa-trash-alt"
              className="text-red-500 mb-4"
              size="3x"
            />
            <h3 className="text-xl text-white font-bold mb-4">
              ¿Eliminar evento?
            </h3>
            <p className="text-gray-200 mb-2">
              Estás a punto de eliminar el evento:
            </p>

            <p className="text-white font-semibold mb-6">"{ticket?.nombre}"</p>

            {/* Input para agregar escribir el nombre del evento para que se confirme la eliminación*/}
            <input
              value={confirmEventName}
              onChange={(e) => {
                setConfirmEventName(e.target.value);
                setShowNameError(false);
              }}
              type="text"
              placeholder="Escribe el nombre del evento para confirmar"
              className={`w-full p-2 rounded border text-white bg-aw-bluedark focus:outline-none focus:ring-2 focus:ring-aw-green ${
                showNameError ? "border-red-500" : "border-gray-300"
              } ${showNameError ? "mb-2" : "mb-4"}`}
            />

            {showNameError && (
              <p className="text-red-500 text-sm mb-4 text-left">
                ⚠ No puedes eliminar el evento porque no has escrito con
                exactitud el nombre del evento.
              </p>
            )}

            <p className="text-gray-300 mb-6">
              Esta acción no se puede deshacer. Se eliminarán todos los tickets
              y configuraciones asociadas.
            </p>

            <div className="flex gap-3 justify-center">
              <button
                onClick={() => {
                  setShowDeleteModal(false);
                  setConfirmEventName("");
                  setShowNameError(false);
                }}
                disabled={isDeleting}
                className="px-6 py-3 bg-gray-600 text-white rounded-lg font-semibold hover:bg-gray-700 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Cancelar
              </button>
              <button
                onClick={handleDeleteEvento}
                disabled={isDeleting || confirmEventName !== ticket?.nombre}
                className="px-6 py-3 bg-red-600 text-white rounded-lg font-semibold hover:bg-red-700 transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
              >
                {isDeleting ? (
                  <>
                    <FontAwesomeIcon
                      icon="fa-solid fa-spinner"
                      className="animate-spin"
                    />
                    Eliminando...
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon="fa-solid fa-trash" />
                    Eliminar
                  </>
                )}
              </button>
            </div>
          </div>
        </Modal>
      )}

      {/* Modal para duplicar evento */}
      {showDuplicateModal && (
        <Modal
          isOpen={showDuplicateModal}
          onClose={() => setShowDuplicateModal(false)}
          large="max-w-4xl"
        >
          <DuplicarEvento
            eventoOriginal={ticket}
            uidEmpresa={idEmpresa}
            onClose={() => setShowDuplicateModal(false)}
          />
        </Modal>
      )}
    </>
  );
}
